import script from "./EmptyCube.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyCube.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyCube.vue?vue&type=style&index=0&id=6643f9c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6643f9c9"]])

export default __exports__